/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1sKx9ffix1qWmdscEUQHh6
import { createUseGlobalVariants } from "@plasmicapp/react-web";
import { useScreenVariants as useScreenVariantsyLvA3Pe9NsN7 } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: yLvA3Pe9NsN7/globalVariant

export const _useGlobalVariants = createUseGlobalVariants({
  screen: useScreenVariantsyLvA3Pe9NsN7
});
